module.exports = __webpack_public_path__ + "mainassets/img/bgwhitereverse.a59e0208.svg";